// extracted by mini-css-extract-plugin
export var headerStyles = "header-module--headerStyles--1Iqi5";
export var headerAestheticStyles = "header-module--headerAestheticStyles--JHuvD";
export var headerTextBgStyles = "header-module--headerTextBgStyles--LhAd9";